<template>
    <poverty-visualization :charts="charts" :title="title" :initial-chart-id="initialChartId" :metric="metric" :y-domain="yDomain" :numeral-format="numeralFormat"></poverty-visualization>
</template>
<script>
    import PovertyVisualization from './PovertyVisualization';
    export default{
        data: function(){
            return {
                title: 'Ingreso Monetario',
                initialChartId: 'decil',
                metric: 'ingreso',
                numeralFormat: '0,0',
                yDomain: [0, 1600000],
                charts: [
                    {
                        id: 'decil',
                        title: 'Deciles',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQPwcREf-6c7OfSFHZK3dM93evM6lIWkbDcr2zN6rLy6gWk3bG09XZ2bWxKF5HwEEEzjeNSL5k6egYy/pub?gid=0&single=true&output=csv',
                        countryFile: '',
                        dimensions: ['decil','decil']
                    },
                    {
                        id: 'region',
                        title: 'Regiones',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSOnm2tqRyBArFdc5GsCZsNxPqFPwtafhtqGCaa3UHZiqbwjvar89Qvf4IAfOIoA_MxDrrFLH1wiKYW/pub?gid=0&single=true&output=csv',
                        countryFile: '',
                        dimensions: ['region','region']
                    }
                ],
            }
        },
        components: {
            PovertyVisualization
        }

    }
</script>


// WEBPACK FOOTER //
// src/js/Components/Visualizations/MoneyIncomeVisualization.vue